import { MenuProps, GroupBase, components } from 'react-select-5';

import ArrowTopMini from 'components/shared/Icon/icons/ArrowTopMini';
import EnterIcon from 'components/shared/Icon/icons/EnterIcon';

import s from './styles.module.css';

export const Menu = function <Option, IsMulti extends boolean, Group extends GroupBase<Option>>(
  props: MenuProps<Option, IsMulti, Group>,
) {
  return (
    <components.Menu {...props}>
      {props.children}

      <div className={s.hint}>
        <div className={s.hintItem}>
          <ArrowTopMini width="1.4rem" height="1.4rem" />
          <span>to navigate</span>
        </div>

        <div className={s.hintItem} style={{ gridColumnStart: 3 }}>
          <EnterIcon width="1.4rem" height="1.4rem" stroke="currentColor" />
          <span>to select</span>
        </div>

        <div className={s.hintItem} style={{ gridColumnStart: 5 }}>
          <span className={s.bold}>esc</span>
          <span>to dismiss</span>
        </div>
      </div>
    </components.Menu>
  );
};
